import { IBaseDataObject } from "./BaseDataObject";
import { IUserInfo } from "./IUserInfo";

export class DataStoreUtilities {
    static setupSaveHistoryFields(data: IBaseDataObject, user: IUserInfo) {
        if (!data.createdBy) {
            data.createdBy = user.userEmail;
            data.createdOn = new Date();
        }

        data.lastSavedBy = user.userEmail;
        data.lastSavedOn = new Date();
    }
}
